"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithCollapse = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("../../atoms/icons");
const WithCollapse = ({ header, body, isOpen = true, className }) => {
    const [isCollapsed, toggleCollapsed] = (0, react_1.useState)(isOpen);
    const handleToggleCollapse = (0, react_1.useCallback)(() => toggleCollapsed(!isCollapsed), [isCollapsed]);
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { className: className, isCollapsed: isCollapsed, children: [(0, jsx_runtime_1.jsxs)("div", { onClick: handleToggleCollapse, children: [header, (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: !isCollapsed ? ["fas", "caret-down"] : ["fas", "caret-up"], color: "grey" }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)("div", { children: body }, void 0)] }, void 0));
};
exports.WithCollapse = WithCollapse;
const Wrapper = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};

  & > div:first-of-type {
    align-items: center;
    border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
    display: flex;
    padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};
    width: 100%;
    ${({ isCollapsed }) => (!isCollapsed ? "border-bottom: none" : "")};
  }

  & > div:first-of-type > *:not(:last-child) {
    flex: 1;
  }

  & > div:first-of-type {
    cursor: pointer;
  }

  & > div:last-of-type {
    display: ${({ isCollapsed }) => (isCollapsed ? "block" : "none")};
    height: 100%;
    padding: ${({ theme, isCollapsed }) => isCollapsed ? `${theme.spacings.m} ${theme.spacings.xl}` : "0"};
    overflow: hidden;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & > div:last-of-type {
      padding: ${({ theme, isCollapsed }) => isCollapsed
    ? `${theme.spacings.xs} ${theme.spacings.m} ${theme.spacings.m}`
    : "0"};
    }
  }
`;
//# sourceMappingURL=index.js.map